import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import classes from "./LandingPageV2.module.css";
import HeroImage from "../assets/events/tribal_image.jpg";
import Events from "../components/events/Events";

const whyItems = [
  { icon: "mdi:timer-outline", label: "Timing Services", color: "orange" },
  { icon: "mdi:trophy", label: "Event Management", color: "orange" },
  { icon: "mdi:account-group", label: "Community", color: "green" },
  { icon: "mdi:chart-bar", label: "Results portal", color: "green" },
];

export default function LandingPageV2() {
  return (
    <>
      <section className={classes.intro}>
        <div className={classes.introImage}>
          <img src={HeroImage} alt="Tribal Running group on a trail run" />
        </div>
        <div className={classes.introContent}>
          <h2>Why We Run Together?</h2>
          <p>
            Tribal Running is a Race/Event organiser across multiple terrains
            from Trail to Track & Field, Cross Country to Road, and much
            more.
          </p>
          <p>
            It is a community that prides itself on looking after its
            athletes both on and off the area of competition with as much
            support and back up as possible — in sport and in life.
          </p>
          <Link to="/coaching" className={classes.btnPrimary}>
            Join a Group Run
          </Link>
        </div>
      </section>


      <section className={classes.eventsSection}>
        <div className={classes.eventsHeader}>
          <h2>Upcoming Events</h2>
          <p>Race with the tribe at our next events around the area.</p>
        </div>
        <Events title="UPCOMING EVENTS" limit={3} />
        <Link to="/events" className={classes.btnSecondary}>
          See All Events
        </Link>
      </section>

      <section className={classes.whySection}>
        <h2>Why Tribal Running?</h2>
        <div className={classes.whyGrid}>
          {whyItems.map(({ icon, label, color }) => (
            <div className={classes.whyItem} key={label}>
              <Icon
                icon={icon}
                width={44}
                height={44}
                className={
                  color === "orange" ? classes.iconOrange : classes.iconGreen
                }
              />
              <p>{label}</p>
            </div>
          ))}
        </div>
      </section>

    </>
  );
}
